import { useId } from 'react'
import { Box, Paper, Table, TableContainer } from '@mui/material'
import SearchRow from '@/components/SecondaryLeftNavigation/components/SearchRow'
import SettingsSectionIntro from '@/components/Settings/SettingsSectionIntro'
import { getSettingsSectionIntro } from '@/components/Settings/settingsSectionDescriptions'
import shared from '@/components/Settings/settingsShared.module.scss'
import InvoicesTableBody from '@/components/Settings/SettingsPageContent/InvoicesTableBody'
import InvoicesTableHead from '@/components/Settings/SettingsPageContent/InvoicesTableHead'
import { useInvoiceDetailsModel } from '@/components/Settings/SettingsPageContent/useInvoiceDetailsModel'

export default function InvoiceDetailsSection() {
  const { invoiceQuery, setInvoiceQuery, filteredInvoices } = useInvoiceDetailsModel()
  const invoiceHeadingId = useId()
  const invoiceIntro = getSettingsSectionIntro('billing-invoices')
  return (
    <Box component="section" aria-labelledby={invoiceHeadingId} className={shared.invoicesSection}>
      {invoiceIntro ? <SettingsSectionIntro headingId={invoiceHeadingId} lines={invoiceIntro} /> : null}
      <Box className={shared.searchRowWrap}>
        <SearchRow value={invoiceQuery} onChange={setInvoiceQuery} placeholder="Search invoices" />
      </Box>
      <TableContainer component={Paper} elevation={0} className={shared.tableContainerPaper}>
        <Box className={shared.tableInnerClip}>
          <Table size="small" className={shared.tableRoot}>
            <InvoicesTableHead />
            <InvoicesTableBody rows={filteredInvoices} />
          </Table>
        </Box>
      </TableContainer>
    </Box>
  )
}
